<div class="w-full">
  <label
    id="listbox-label"
    class="block text-sm font-medium leading-6 text-gray-900"
    >{{ label }}</label
  >
  <div class="relative" #ref>
    <button
      type="button"
      class="relative w-full cursor-default h-[46px] rounded-[4px] border-[2px] bg-white py-1.5 pl-4 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-black text-sm leading-6"
      [class.ring-[#f56978]]="error"
      [class.ring-2]="error"
      aria-haspopup="listbox"
      aria-expanded="true"
      aria-labelledby="listbox-label"
      (click)="toggle()"
    >
      <span
        *ngIf="selectedName"
        class="block text-sm font-bold leading-7 px-[5px] overflow-hidden absolute top-[-12px] bg-white"
        >{{ placeholder }}</span
      >

      <span class="block truncate text-base font-normal leading-7">{{
        selectedName || placeholder
      }}</span>
      <span
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
      >
        <svg
          class="h-5 w-5 text-gray-400"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </button>

    <ul
      class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none text-sm transition ease-in duration-100"
      [class.opacity-0]="!opened"
      [class.hidden]="!opened"
      [class.opacity-100]="opened"
      tabindex="-1"
      role="listbox"
      aria-labelledby="listbox-label"
      aria-activedescendant="listbox-option-3"
    >
      <li
        *ngIf="searchEnabled"
        class="text-gray-900 relative cursor-default select-none py-2 px-4 text-base font-normal"
        role="option"
      >
        <div class="mt-2">
          <input
            type="text"
            name="search"
            id="search"
            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm placeholder:text-gray-400 sm:text-sm sm:leading-6 bg-white px-2 ring-1 ring-gray-300"
            (input)="searchChange($event)"
            [value]="searchTerm"
            [placeholder]="searchPlaceholder"
          />
        </div>
      </li>

      <li
        *ngFor="let item of filteredItems"
        class="text-gray-900 relative cursor-default select-none py-2 px-4 text-base font-normal"
        [class.bg-gray-200]="item.selected"
        [id]="item.value"
        role="option"
        (click)="itemSelect(item)"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</div>
<div *ngIf="error" class="mt-[10px]">
  <span class="text-[#f56978] font-semibold text-[14px]">{{ errorLabel }}</span>
</div>
